export default __webpack_public_path__ + "static/media/s7.9e36d789.jpeg";